import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map } from 'rxjs';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeepayslipserviceService {

  constructor(
    private http: HttpClient,
    private session: SessionService
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  GetEmployeeDetails(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `LoadEmployeeReport/EmployeeLoad`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  PrintPayslip(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `EmployeePayslipDownload`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetSiteCode(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `GetSiteCodeDetails`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
